import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { AuthStateService } from "./core/authentication/auth-state.service";
import { ConfigService } from "./shared/services/config.service";
import { AuthUser } from "./core/authentication/auth.model";

export const sessionInitializer = () => {
    return async () => {
        const http = inject(HttpClient);
        const authState = inject(AuthStateService);
        const config = inject(ConfigService);
        const base = config.apiBaseUrl;


        try {
            // 1. Try /users/me with the current access token cookie
            const user = await firstValueFrom(
                http.get<AuthUser>(`${base}/users/me`, { withCredentials: true, headers: { 'X-Platform': 'WEB' } })
            );
            authState.setSession(user);

        } catch (err) {
            if (err instanceof HttpErrorResponse && err.status === 401) {
                try {
                    // 2. Access token expired → attempt silent refresh
                    await firstValueFrom(
                        http.post<void>(`${base}/auth/refresh`, {}, { withCredentials: true, headers: { 'X-Platform': 'WEB' } })
                    );

                    // 3. Refresh succeeded → retry /users/me with the new access token
                    const user = await firstValueFrom(
                        http.get<AuthUser>(`${base}/users/me`, { withCredentials: true, headers: { 'X-Platform': 'WEB' } })
                    );
                    authState.setSession(user);

                } catch {
                    // 4. Refresh also failed (expired/revoked) → user must log in again
                    authState.clearSession();
                }
            } else {
                // Non-401 error (network down, 403 deactivated, etc.)
                authState.clearSession();
            }
        }
    }
}

